import { defineMessages } from "react-intl";
import { AccountVerificationType } from "../../contract/pam.js";
const localizedAccountVerificationType = defineMessages({
  [AccountVerificationType.Payment]: {
    id: "accountVerificationTypePayment",
    defaultMessage: "Payment"
  },
  [AccountVerificationType.Security]: {
    id: "accountVerificationTypeSecurity",
    defaultMessage: "Security"
  },
  [AccountVerificationType.NdrpVerification]: {
    id: "accountVerificationTypeNDRP",
    defaultMessage: "NDRP"
  }
});
export {
  localizedAccountVerificationType
};
//# sourceMappingURL=accountVerificationType.js.map
